import { lazy, Suspense } from 'react';
import { Link } from 'react-router-dom';
import Arrow from './redesign/Arrow';
import AgentSpaceFallback from './redesign/AgentSpaceFallback';
const AgentSpace = lazy(() => import('./redesign/AgentSpace'));
export default function HeroSection() {
  return <section className="hero hero-agent-space" aria-labelledby="hero-heading">
    <div className="hero-space-background">
      <Suspense fallback={<AgentSpaceFallback />}><AgentSpace /></Suspense>
    </div>
    <div className="hero-copy">
      <h1 id="hero-heading" className="hero-heading"><span className="hero-line">最先端のIT技術で</span><span className="hero-line">ビジネスに<span className="blue-type">革新</span>を。</span></h1>
      <div className="hero-japanese">
        <p>構想から開発、運用まで、<br className="hero-mobile-break" />事業の成果に伴走します。</p>
        <p className="hero-english" lang="en">Driving business innovation with cutting-edge IT.<br />From concept to development and operations, we partner with you to drive business results.</p>
      </div>
      <Link to="/service" className="text-link hero-link">私たちにできること <Arrow /></Link>
    </div>
    <div className="hero-bottom"><a href="#products" className="scroll-link">サービスを見る <span aria-hidden="true">↓</span></a></div>
  </section>;
}
